/** @jsxImportSource @emotion/react */
import { SerializedStyles, css } from '@emotion/react';
import { WabaChannelRating } from '../typings/waba';

export const getWabaIntegrationQualityRatingStyles = (
  wabaChannelRating: WabaChannelRating
): SerializedStyles => {
  return css`
    color: ${wabaChannelRating === WabaChannelRating.LOW
      ? '#C21313'
      : wabaChannelRating === WabaChannelRating.HIGH
      ? '#2C8E47'
      : wabaChannelRating === WabaChannelRating.MEDIUM
      ? '#E7961C'
      : 'inherit'};
    background-color: ${wabaChannelRating === WabaChannelRating.LOW
      ? 'rgba(194, 19, 19, 0.12)'
      : wabaChannelRating === WabaChannelRating.HIGH
      ? 'rgba(93, 183, 121, 0.20)'
      : wabaChannelRating === WabaChannelRating.MEDIUM
      ? 'rgba(231, 150, 28, 0.20)'
      : '#FFFFFF'};
  `;
};
